import classnames from 'classnames/bind'

// Components
import Icon from '@/assets/icons'

// Libs
import useHideProduct from '@/hooks/livemallclub/useHideProduct'
import useHideRoom from '@/hooks/livemallclub/useHideRoom'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

export type VisibilityMaskProps = {
  initialVisibility: boolean
  id: string | number
  type?: 'room' | 'product'
}

const VisibilityMask = ({ initialVisibility, id, type }: VisibilityMaskProps) => {
  const { isVisible: isVisibleRoom, handleHideRoom } = useHideRoom({ initialVisibility, roomId: String(id) })
  const { isVisible: isVisibleProduct, handleHideProduct } = useHideProduct({ initialVisibility, productId: Number(id) })
  const visibleStateMap: Map<VisibilityMaskProps['type'], boolean> = new Map([
    [undefined, true],
    ['room', isVisibleRoom],
    ['product', isVisibleProduct],
  ])
  const isVisible = visibleStateMap.get(type)

  const handleHide = () => {
    switch (type) {
      case 'room':
        handleHideRoom()
        break
      case 'product':
        handleHideProduct()
        break
      default:
        return
    }
  }

  return (
    <div className={cx('visibility-mask')} onClick={handleHide}>
      <div className={cx('visibility-mask__mask', { isVisible })} />
      <div className={cx('visibility-mask__icon', { isVisible })}>{isVisible ? <Icon.EyeOpen_HollowEyeball /> : <Icon.EyeClose_Wide />}</div>
    </div>
  )
}

export default VisibilityMask
